import deepmerge from 'deepmerge';
import { isPlainObject } from 'is-plain-object';
import { runPlayerExtension } from '../../../util/player-extensions.js';

/**
 * 
 * @param {any} player
 * @param {string} presentationId
 * @param {PlayCoverData} playCoverData
 * @param {PresentationData} presentationData
 * @param {Array<LoaderCallback>} loaderHooks
 * @returns {Promise<PresentationData>}
 */
export function applyLoaderCallbacks(player, presentationId, playCoverData, presentationData, loaderHooks) {
    const hooks = loaderHooks.map(hook => hook?.(presentationId, playCoverData, presentationData));
    const extensions = presentationData.playerExtensions ?? [];
    const extensionHooks = getPlayerExtensionHooks(player, extensions);
    hooks.push(...extensionHooks);

    return Promise.all(hooks).then(pluginResults => {
        const result = deepmerge.all(
            [presentationData, ...pluginResults.filter(val => val !== undefined)],
            { isMergeableObject: isPlainObject }
        );
        return result;
    });
}

function getPlayerExtensionHooks(player, extensions) {
    const SKIP_EXTENSION_TYPES = ['Mediasite.Player.PollNotification', 'Mediasite.Player.SurveyExtension', 'Mediasite.Player.CopyrightExtension'];
    const results = [];

    extensions.forEach(function (extension) {
        if (SKIP_EXTENSION_TYPES.includes(extension.ExtensionType)) {
            // Some legacy extensions are now built into the player.
            // The server-side data for those extensions still necessary, 
            // so leave all that in and specifically don't load the,
            // now unnecessary, extension code.
            return;
        }

        let promise = runPlayerExtension(videojs, player, extension);
        results.push(promise);
    });

    return results;
}
